import type { Bucket } from '@/entities/bucket';
import request from '@/shared/api/request';

export const updateBucketSettings = (
  name: string,
  acl: Bucket['acl'],
): Promise<{ bucket: Bucket }> =>
  request({
    url: `/buckets/${name}/`,
    method: 'PUT',
    data: { acl },
  });
